const apply_grade = [
	{ label: '一年级', value: 1 },
	{ label: '二年级', value: 2 },
	{ label: '三年级', value: 3 },
	{ label: '四年级', value: 4 },
	{ label: '五年级', value: 5 },
	{ label: '六年级', value: 6 },
	{ label: '初一', value: 7 },
	{ label: '初二', value: 8 },
	{ label: '初三', value: 9 },
	{ label: '高一', value: 10 },
	{ label: '高二', value: 11 },
	{ label: '高三', value: 12 }
]
const typeList = [
	{ label: '单选题', value: 1 },
	{ label: '多选题', value: 2 },
	{ label: '填空题', value: 3 },
	{ label: '连线题', value: 11 },
	{ label: '可视化演唱题', value: 9 }
]
const fb_apply_volume = [
	{ label: '上册', value: 1 },
	{ label: '下册', value: 2 },
	{ label: '全部', value: 3 }
]
const difficultyList = [
	{ label: '容易', value: '容易' },
	{ label: '简单', value: '简单' },
	{ label: '困难', value: '困难' }
]

const is_down = [
	{ label: '上架中', value: 0 },
	{ label: '已下架', value: 1 }
]

const primarySchool = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' }
]
const middleSchool = [
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' }
]
const highSchool = [
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const all_grade = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' },
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' },
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]

const fileType = [
	{ val: '.jpeg, .jpg, .png, .gif, .svg, .webp', name: '图片', id: 1 },
	{ val: '.mp3, .wav, .ogg, .m4a', name: '音频', id: 2 },
	{ val: '.mp4, .webm, .ogv, .m4v', name: '视频', id: 3 }
]


// 2024.01.02 10:28 书荣
const adminIdentity = [
	{ name: '平台', id: 1 },
	// { name: '教研', id: 2 },
	{ name: '教师', id: 3 }
]
const teacherIdentity = [
	{ name: '自有', id: 5 },
	{ name: '校方', id: 4 },
	// { name: '教研', id: 2 },
	{ name: '平台', id: 1 }
]

const schoolIdentity = [
	{ name: '校方', id: 4 },
	// { name: '教研', id: 2 },
	{ name: '平台', id: 1 }
]

const researchIdentity = [
	{ name: '教研', id: 2 }
]

export {
	apply_grade,
	typeList,
	fb_apply_volume,
	difficultyList,
	is_down,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	fileType,
  adminIdentity,
  teacherIdentity,
  schoolIdentity,
  researchIdentity
}
